module.exports = __webpack_public_path__ + "static/media/HM-Logo-Marca Registrada Sin Tagline[7790].217e9eb5.png";